var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#2AABEE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.4,
    height: 26.4,
    transform: "translate(12 12)",
    fill: "#2AABEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.626 23.4385C20.9753 20.6722 25.2092 18.8485 27.3276 17.9674C33.3762 15.4516 34.633 15.0146 35.4522 15.0002C35.6324 14.997 36.0352 15.0416 36.2962 15.2534C36.5165 15.4322 36.5771 15.6737 36.6061 15.8432C36.6352 16.0127 36.6713 16.3989 36.6426 16.7006C36.3148 20.1445 34.8965 28.502 34.175 32.3593C33.8697 33.9915 33.2685 34.5387 32.6865 34.5923C31.4217 34.7086 30.4613 33.7564 29.2363 32.9534C27.3193 31.6968 26.2364 30.9146 24.3757 29.6884C22.2253 28.2714 23.6193 27.4925 24.8448 26.2197C25.1655 25.8866 30.7383 20.8177 30.8462 20.3579C30.8596 20.3004 30.8722 20.086 30.7448 19.9728C30.6175 19.8596 30.4295 19.8983 30.2939 19.9291C30.1016 19.9728 27.0393 21.9968 21.1069 26.0013C20.2377 26.5982 19.4504 26.889 18.745 26.8738C17.9673 26.857 16.4714 26.4341 15.3594 26.0726C13.9954 25.6292 12.9113 25.3948 13.0057 24.6418C13.0549 24.2496 13.595 23.8485 14.626 23.4385Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIconFilled);
export default __webpack_public_path__ + "static/media/telegramIconFilled.ccacae870b0c3c46b5e5f30811a5261a.svg";
export { ForwardRef as ReactComponent };